import React, {useState} from "react";
import {useTranslation} from "react-i18next";
//local
import {Input} from "components/Input";
import Upload from "components/Upload";
import {IconMenuCircle} from "components/icons";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import ButtonDelete from "components/buttons/ButtonDelete";

const QualificationQuestion = ({
  question,
  onChange,
  onUploadFile,
  onChangeFiles,
  isOwner,
  loading,
  onDelete,
}) => {
  const {t} = useTranslation();
  const [questionLabel, setQuestionLabel] = useState(question.label);

  const handleChange = (e) => {
    setQuestionLabel(e.target.value);
    onChange({...question, label: e.target.value});
  };

  return (
    <div id={question.id} className="qualifications-questions-modal__question-item">
      <div className="full-width">
        <Input
          tiny
          fullWidth
          readOnly={!isOwner || loading}
          placeholder={t("QUALIFICATION_QUESTIONS_INPUT_PLACEHOLDER")}
          className="input"
          value={questionLabel}
          onChange={handleChange}
        />

        <Upload
          variant="attachment"
          viewMode={!isOwner}
          files={question.files}
          uploadRequest={onUploadFile}
          onChange={(files) => onChangeFiles(files, question.id)}
          disabledUpload={loading}
          customFileSize={102400}
          maxFilesCount={1}
        />
      </div>
      {isOwner && (
        <div className="df-row-center">
          <ButtonDelete
            activeOnHover
            onClick={() => onDelete(question.id)}
            addClass="ml-2 mr-1"
          />
          <ButtonTransparent
            icon={<IconMenuCircle />}
            noBorder
            circular
            onClick={() => true}
            addClass="pa-0 drag-button"
            small
          />
        </div>
      )}
    </div>
  );
};

export default QualificationQuestion;
